 function initLazyImages(scope = document) {
    const images = scope.querySelectorAll('.lazy-image:not(.loaded)');
    images.forEach(function (img) {
      if (img.complete) {
        handleImageLoad(img);
      } else {
        img.addEventListener('load', function () {
          handleImageLoad(img);
        });
      }
    });
  }

  function handleImageLoad(img) {
    const loader = img.parentElement.querySelector('.image-loader');
    if (loader) loader.remove();
    img.classList.add('loaded');
  }

  // Initial page load
  document.addEventListener("DOMContentLoaded", function () {
    initLazyImages();
  });

  // Handle section reloads (in theme editor)
  document.addEventListener("shopify:section:load", function (event) {
    initLazyImages(event.target);
  });

  // Observer to detect injected recommendation HTML
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1 && node.matches && node.matches('product-recommendations')) {
          initLazyImages(node);
        } else if (node.nodeType === 1) {
          // Check for nested lazy images
          initLazyImages(node);
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });